import { createApi, DefaultResponsePlugin, LanguageHeaderPlugin } from '@core';
import { AuthHeaderPlugin, RefreshTokenPlugin } from '@shared';
import modules from '../api-modules';

const api = createApi({ modules });
api.registerPlugins([DefaultResponsePlugin, AuthHeaderPlugin, RefreshTokenPlugin, LanguageHeaderPlugin]);

export const useApi = () => api.getModules();
